import { createSelector } from 'reselect';

const selectorData = (state: any) => state.LogActivityState;

// SELECTOR LOG ACTIVITY
export const makeLogActivityDataListSelector = () =>
  createSelector(selectorData, state => state.logActivityDataList);